module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_vm._m(0), _c('div', {
    staticClass: "container stepup-uncheck bg04"
  }, [_vm._m(1), _c('div', {
    staticClass: "row inner"
  }, [_c('p', {
    staticClass: "fz14 bold",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("評価シートをまだ回答されてない方")]), _c('div', {
    staticClass: "user-post-detail__body__others bg05"
  }, _vm._l((_vm.nonAnswers), function(nonAnswer, index) {
    return _c('div', [(index === 0 || nonAnswer.evaluate_answer_user_id !== _vm.nonAnswers[index - 1].evaluate_answer_user_id) ? _c('div', [_c('span', {
      staticClass: "answer_deadline",
      style: (_vm.first(index))
    }, [_vm._v("人事評価対象者：" + _vm._s(nonAnswer.evaluate_answer_user_name)), _c('br'), _vm._v("回答期限：〜" + _vm._s(nonAnswer.end_date) + "まで")]), _c('div', {
      staticClass: "user-outline"
    }, [(nonAnswer.profile_image_path) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": nonAnswer.profile_image_path + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(nonAnswer.user_type_name))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(nonAnswer.user_name))])])])]) : _c('div', [_c('div', {
      staticClass: "user-outline"
    }, [(nonAnswer.profile_image_path) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": nonAnswer.profile_image_path + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(nonAnswer.user_type_name))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(nonAnswer.user_name))])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("戻る")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "stepup-uncheck__heading"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("店舗長と事務の方へ"), _c('br'), _vm._v("お手数ですが"), _c('br'), _vm._v("声かけをお願いしますニャン！")])]), _c('p', {
    staticClass: "stepup-uncheck__lead bg06 fz15"
  }, [_vm._v("まだ「評価シートの回答」が済んでいないスタッフの方には、そっと声かけをお願いいたします。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68f4ddd0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/evaluate-answer-call-list.pug
// module id = 1412
// module chunks = 1